export const whyCards = [
  {
    icon: "ri-time-line",
    title: "Oszczędzaj czas",
    description: "Nie trać godzin na przeszukiwanie setek produktów. Nasze gotowe listy Kakobuy Spreadsheet pomagają błyskawicznie znaleźć najlepsze produkty z Chin, oszczędzając Twój cenny czas.",
  },
  {
    icon: "ri-search-eye-line",
    title: "Znajduj najlepsze okazje",
    description: "Porównuj produkty, ceny i popularne wybory społeczności Kakobuy. Dzięki naszemu arkuszowi kalkulacyjnemu zawsze trafisz na najlepsze oferty i ukryte perełki.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Kupuj świadomie i bezpiecznie",
    description: "Poznaj cały proces zakupowy: od kontroli jakości QC, przez bezpieczną wysyłkę, aż po dostawę do Polski. Kakobuy Spreadsheet to Twoje kompletne narzędzie zakupowe.",
  },
];

export const comparisonData = [
  {
    feature: "Gotowe linki do produktów",
    spreadsheet: true,
    standard: false,
  },
  {
    feature: "Kategorie produktów",
    spreadsheet: true,
    standard: false,
  },
  {
    feature: "Oszczędność czasu",
    spreadsheet: "Bardzo duża",
    standard: "Niska",
  },
  {
    feature: "Popularne produkty społeczności",
    spreadsheet: true,
    standard: "Trudne do znalezienia",
  },
  {
    feature: "Porównanie cen i jakości",
    spreadsheet: true,
    standard: "Brak",
  },
  {
    feature: "Aktualizowane listy",
    spreadsheet: true,
    standard: false,
  },
  {
    feature: "Wsparcie społeczności",
    spreadsheet: true,
    standard: "Ograniczone",
  },
  {
    feature: "Poradniki zakupowe",
    spreadsheet: true,
    standard: false,
  },
];

export const howItWorksSteps = [
  {
    step: 1,
    icon: "ri-list-check-2",
    title: "Wybierz kategorię",
    description: "Przeglądaj nasze starannie posegregowane kategorie produktów w Kakobuy Spreadsheet i znajdź dokładnie to, czego szukasz.",
  },
  {
    step: 2,
    icon: "ri-shopping-bag-3-line",
    title: "Znajdź produkt",
    description: "Skorzystaj z gotowych linków i sprawdzonych rekomendacji, aby szybko trafić na najlepsze produkty od zaufanych sprzedawców.",
  },
  {
    step: 3,
    icon: "ri-file-search-line",
    title: "Sprawdź informacje",
    description: "Zapoznaj się ze zdjęciami QC, opiniami innych kupujących i szczegółowymi opisami przed podjęciem decyzji zakupowej.",
  },
  {
    step: 4,
    icon: "ri-bank-card-line",
    title: "Kup przez platformę",
    description: "Złóż zamówienie bezpiecznie przez platformę Kakobuy, korzystając z preferowanej metody płatności i opcji wysyłki.",
  },
  {
    step: 5,
    icon: "ri-truck-line",
    title: "Odbierz przesyłkę",
    description: "Śledź swoją paczkę na każdym etapie i ciesz się nowymi produktami dostarczonymi prosto pod Twoje drzwi w Polsce.",
  },
];

export const blogArticle = {
  slug: "kakobuy-spreadsheet-poradnik",
  title: "Kakobuy Spreadsheet – Kompletny Poradnik dla Kupujących z Polski 2026",
  excerpt: "Dowiedz się, jak efektywnie korzystać z Kakobuy Spreadsheet, aby znaleźć najlepsze produkty z Chin. Praktyczne wskazówki, porównania kategorii i strategie oszczędzania dla polskich kupujących.",
  imageSeq: "blog-main-01",
  imageQuery: "Modern%20workspace%20with%20laptop%20displaying%20spreadsheet%20data%2C%20minimal%20desk%20setup%20with%20warm%20natural%20lighting%2C%20clean%20aesthetic%2C%20cream%20and%20beige%20tones%2C%20professional%20editorial%20photography%2C%20soft%20shadows%2C%20harmonious%20composition",
};